module.exports = __webpack_public_path__ + "static/media/Surg image 1.e112538a.png";